import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock3Icon } from 'lucide-react';
const STORAGE_KEY = 'professeur_danse_pro_countdown';
function getInitialTarget(): number {
  const stored = window.localStorage.getItem(STORAGE_KEY);
  const parsed = stored ? Number.parseInt(stored, 10) : 0;
  if (parsed > Date.now()) return parsed;
  const target = Date.now() + 24 * 60 * 60 * 1000;
  window.localStorage.setItem(STORAGE_KEY, String(target));
  return target;
}
function pad(value: number) {
  return value.toString().padStart(2, '0');
}
export function CountdownTimer() {
  const [remaining, setRemaining] = useState(24 * 60 * 60 * 1000);
  useEffect(() => {
    let target = getInitialTarget();
    const tick = () => {
      if (target <= Date.now()) target = getInitialTarget();
      setRemaining(Math.max(0, target - Date.now()));
    };
    tick();
    const timer = window.setInterval(tick, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const hours = Math.floor(remaining / 3600000);
  const minutes = Math.floor(remaining % 3600000 / 60000);
  const seconds = Math.floor(remaining % 60000 / 1000);
  return <motion.div initial={{
    opacity: 0,
    y: 14
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.3,
    ease: [0.23, 1, 0.32, 1]
  }} className="mx-auto mt-12 max-w-3xl rounded-xl border border-brand-gold/50 bg-white p-6 text-center shadow-card sm:p-8" data-id="element-45" data-mp="1h12z03j6h3qv">
      <div className="flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-[0.12em] text-brand-deep" data-id="element-46" data-mp="1zq9kfybcw9gd">
        <Clock3Icon size={18} aria-hidden="true" data-id="element-47" data-mp="1l1wmwwwmeijr" /> L’offre à 27 EUR se termine
        dans
      </div>
      <div className="mt-6 flex items-center justify-center gap-2 sm:gap-4" data-id="element-48" data-mp="1pzocvldpfulb">
        <TimeBox value={pad(hours)} label="h" data-id="element-49" data-mp="2dqakxcnplevb" />
        <span className="text-2xl text-brand-gold" data-id="element-50" data-mp="2dp8zce92h9zc">:</span>
        <TimeBox value={pad(minutes)} label="min" data-id="element-51" data-mp="2igh9xdm4v1e3" />
        <span className="text-2xl text-brand-gold" data-id="element-52" data-mp="2ii20ks5bu06o">:</span>
        <TimeBox value={pad(seconds)} label="s" data-id="element-53" data-mp="2sczhp6qktdy0" />
      </div>
      <p className="mt-6 text-sm font-semibold text-brand-ink" data-id="element-54" data-mp="2sada573oqyfs">
        Profitez du système complet et des 5 bonus au prix actuel.
      </p>
      <div className="mt-6 text-left" data-id="element-55" data-mp="2jb9r234iqj1a">
        <div className="mb-2 flex justify-between gap-4 text-xs font-medium text-brand-muted" data-id="element-56" data-mp="2ja8696xpai6d">
          <span data-id="element-57" data-mp="2ecos071065ef">Accès au prix actuel</span>
          <span className="font-semibold text-brand-deep" data-id="element-58" data-mp="29dlmyml0vz6g">
            Plus que quelques places
          </span>
        </div>
        <div className="h-2 overflow-hidden rounded-full bg-brand-blush" data-id="element-59" data-mp="24m3tskp8r2w1">
          <div className="h-full w-[65%] rounded-full bg-brand-coral" data-id="element-60" data-mp="1znk72i2tpn2m" />
        </div>
        <p className="mt-2 text-right text-xs text-brand-muted" data-id="element-61" data-mp="1vmguq5jzi965">
          65 % des places déjà prises
        </p>
      </div>
    </motion.div>;
}
function TimeBox({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="min-w-[74px] rounded-lg border border-brand-line bg-brand-cream px-3 py-3 sm:min-w-[100px]" data-id="element-62" data-mp="1lo12u0d4uvvl">
      <span className="font-display text-3xl font-semibold tabular-nums text-brand-ink sm:text-4xl" data-id="element-63" data-mp="15gom5rqk8hc">
        {value}
      </span>
      <span className="ml-1 text-xs font-semibold text-brand-deep" data-id="element-64" data-mp="67ft5iz7pbfv">
        {label}
      </span>
    </div>;
}